import type { CSSProperties } from "react";
import { cx } from "@/lib/cx";
import { readableInk, tagInk } from "@/lib/format";

interface TagProps {
  label: string;
  /** Cor da etiqueta (hex). A tinta e calculada por luminancia (RF-UX-084). */
  color?: string;
  /** Chip contido: fundo translucido na cor da etiqueta + tinta AA. */
  soft?: boolean;
  className?: string;
  styles?: CSSProperties;
}

/** Etiqueta sempre com rotulo textual, nunca so cor (RF-UX-088). */
export function Tag({ label, color, soft, className, styles }: TagProps) {
  if (!color) {
    return (
      <span className={cx("tag", className)} style={styles}>
        {label}
      </span>
    );
  }

  if (soft) {
    return (
      <span
        className={cx("tag tag-soft", className)}
        style={
          {
            "--tag-color": color,
            "--tag-ink-light": tagInk(color, "light"),
            "--tag-ink-dark": tagInk(color, "dark"),
            ...styles,
          } as CSSProperties
        }
      >
        #{label}
      </span>
    );
  }

  const ink = readableInk(color);
  return (
    <span
      className={cx("tag", className)}
      style={{ background: color, color: ink, borderColor: color, ...styles }}
    >
      #{label}
    </span>
  );
}
